import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaBookOpen, 
  FaStethoscope, 
  FaArrowRight, 
  FaUniversity, 
  FaFlask,
  FaRegLightbulb,
  FaHeartbeat
} from 'react-icons/fa';
import '../css/PremiumSuites.css';

const PremiumSuites = () => {
  return (
    <div className="premium-container">
      <div className="premium-header">
        <h1>Knowledge Resources</h1>
        <p className="subtitle">
          Explore in-depth medical specialty information and theory to guide your career decisions
        </p>
      </div>

      <div className="premium-options">
        <Link to="/theory" className="premium-card theory-card">
          <div className="card-icon-container">
            <FaBookOpen className="card-icon" />
          </div>
          <h2>Medical Theory</h2>
          <p>
            Explore the principles behind personality types and their influence on medical career paths
          </p>
          <ul className="feature-list">
            <li>
              <FaUniversity className="feature-icon" />
              <span>Evidence-based research</span>
            </li>
            <li>
              <FaRegLightbulb className="feature-icon" />
              <span>Psychological insights</span>
            </li>
            <li>
              <FaFlask className="feature-icon" />
              <span>Scientific methodology</span>
            </li>
          </ul>
          <div className="card-action">
            <span>Explore Theory</span>
            <FaArrowRight className="arrow-icon" />
          </div>
        </Link>
        
        <Link to="/specialties" className="premium-card specialties-card">
          <div className="card-icon-container">
            <FaStethoscope className="card-icon" />
          </div>
          <h2>Medical Specialties</h2>
          <p>
            Comprehensive breakdowns of all medical specialties and their career pathways
          </p>
          <ul className="feature-list">
            <li>
              <FaHeartbeat className="feature-icon" />
              <span>Detailed specialty guides</span>
            </li>
            <li>
              <FaArrowRight className="feature-icon" />
              <span>Training pathways</span>
            </li>
            <li>
              <FaStethoscope className="feature-icon" />
              <span>Day-to-day work insights</span>
            </li>
          </ul>
          <div className="card-action">
            <span>Explore Specialties</span>
            <FaArrowRight className="arrow-icon" />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default PremiumSuites;
